import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

/**
 * User Directory Icon Component
 *
 * A network/directory icon for the User Directory feature.
 */
const ConnectIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 49.83 57.117">
      <path
        id="Path_2462"
        d="M2545.631,9.381a4.619,4.619,0,0,1-4-2.351,4.717,4.717,0,0,1-.617-2.341,4.62,4.62,0,1,1,9.239,0,4.747,4.747,0,0,1-.617,2.342,4.617,4.617,0,0,1-4,2.349m0-7.86a3.138,3.138,0,0,0-3.1,3.169,3.192,3.192,0,0,0,.417,1.586l0,0a3.063,3.063,0,0,0,5.36,0,3.225,3.225,0,0,0,.419-1.592,3.138,3.138,0,0,0-3.1-3.169"
        transform="translate(-2520.715 0)"
        fill="#609690"
      />
      <path
        id="Path_2463"
        d="M2429.83,77.454c-.083,0-.166,0-.249-.007h0a4.524,4.524,0,0,1-2.055-.626,4.735,4.735,0,0,1-1.687-6.4,4.594,4.594,0,0,1,2.823-2.195,4.533,4.533,0,0,1,3.495.476,4.655,4.655,0,0,1,1.689,1.719,4.772,4.772,0,0,1,0,4.68c-.047.083-.093.16-.143.235a4.61,4.61,0,0,1-3.87,2.117m-.165-1.525a3.091,3.091,0,0,0,2.761-1.424c.039-.059.067-.107.1-.157a3.242,3.242,0,0,0,0-3.178,3.133,3.133,0,0,0-1.136-1.157,3.023,3.023,0,0,0-2.33-.318,3.085,3.085,0,0,0-1.894,1.476,3.208,3.208,0,0,0,1.135,4.338,3.022,3.022,0,0,0,1.37.418"
        transform="translate(-2425.221 -56.138)"
        fill="#609690"
      />
      <path
        id="Path_2464"
        d="M2429.846,213.623a4.608,4.608,0,0,1-4.01-2.351,4.74,4.74,0,0,1,1.688-6.4,4.574,4.574,0,0,1,6.32,1.717c.045.078.089.162.129.245a4.717,4.717,0,0,1-.414,4.878,4.584,4.584,0,0,1-1.405,1.277,4.538,4.538,0,0,1-2.307.633m-.009-7.862c-.057,0-.115,0-.173,0a3.068,3.068,0,0,0-1.37.418,3.212,3.212,0,0,0-1.136,4.339,3.086,3.086,0,0,0,1.895,1.475,3.022,3.022,0,0,0,2.33-.318,3.07,3.07,0,0,0,.943-.857l0,0a3.206,3.206,0,0,0,.277-3.32c-.028-.059-.054-.108-.082-.155a3.082,3.082,0,0,0-2.685-1.584"
        transform="translate(-2425.222 -168.44)"
        fill="#609690"
      />
      <path
        id="Path_2465"
        d="M2545.62,281.711a4.66,4.66,0,0,1-4.619-4.69,4.726,4.726,0,0,1,.381-1.869,4.593,4.593,0,0,1,8.476,0,4.718,4.718,0,0,1,.382,1.869,4.66,4.66,0,0,1-4.62,4.69m0-7.86a3.1,3.1,0,0,0-2.842,1.9,3.215,3.215,0,0,0-.259,1.27,3.1,3.1,0,1,0,6.2,0,3.208,3.208,0,0,0-.259-1.27h0a3.094,3.094,0,0,0-2.837-1.9"
        transform="translate(-2520.707 -224.594)"
        fill="#609690"
      />
      <path
        id="Path_2466"
        d="M2661.391,213.625a4.545,4.545,0,0,1-2.308-.633,4.627,4.627,0,0,1-1.4-1.275,4.733,4.733,0,0,1-.407-4.892h0c.039-.08.08-.158.125-.236a4.57,4.57,0,0,1,6.315-1.716,4.738,4.738,0,0,1,1.69,6.4,4.608,4.608,0,0,1-4.011,2.353m-3.5-6.492.741.367a3.215,3.215,0,0,0,.276,3.324,3.11,3.11,0,0,0,.944.856,3.024,3.024,0,0,0,2.329.318,3.091,3.091,0,0,0,1.9-1.477,3.211,3.211,0,0,0-1.137-4.338,3.036,3.036,0,0,0-1.37-.418,3.069,3.069,0,0,0-2.854,1.577c-.03.052-.055.1-.079.15Z"
        transform="translate(-2616.187 -168.44)"
        fill="#609690"
      />
      <path
        id="Path_2467"
        d="M2661.438,77.461a4.618,4.618,0,0,1-3.875-2.125c-.05-.081-.093-.15-.134-.222a4.771,4.771,0,0,1,0-4.685,4.646,4.646,0,0,1,1.69-1.718,4.529,4.529,0,0,1,3.493-.476,4.6,4.6,0,0,1,2.825,2.194,4.739,4.739,0,0,1-1.688,6.4,4.608,4.608,0,0,1-2.054.626c-.085,0-.17.007-.254.007m-.011-7.861a3.026,3.026,0,0,0-1.54.423,3.125,3.125,0,0,0-1.137,1.156h0a3.241,3.241,0,0,0,0,3.181c.031.053.065.109.1.165a3.087,3.087,0,0,0,2.756,1.411,3.037,3.037,0,0,0,1.371-.419,3.212,3.212,0,0,0,1.135-4.338,3.084,3.084,0,0,0-1.9-1.475,3.048,3.048,0,0,0-.789-.1"
        transform="translate(-2616.219 -56.145)"
        fill="#609690"
      />
      <path
        id="Path_2478"
        d="M2540.362,128.817a1.288,1.288,0,0,1,.119.509v1.933h-14.509v-1.883a1.285,1.285,0,0,1,.111-.559,1.247,1.247,0,0,1,.574-.609l1.927-.952,2.472-1.221a.279.279,0,0,0,.148-.192.284.284,0,0,0-.057-.237,12.894,12.894,0,0,1-.8-1.125,4.387,4.387,0,0,1-.7-2.382v-1.53c0-4.46,7.112-4.46,7.112,0V122.1a4.389,4.389,0,0,1-.689,2.372,13.133,13.133,0,0,1-.8,1.123.281.281,0,0,0-.056.237.277.277,0,0,0,.147.191l2.5,1.243,1.931.96c.031.016.062.034.092.052a1.332,1.332,0,0,1,.167.125c.025.024.051.048.073.073a1.247,1.247,0,0,1,.232.339"
        transform="translate(-2508.313 -96.677)"
        fill="#b2d7d3"
      />
      <path
        id="Path_2479"
        d="M2537.664,128.442h-16.03v-2.634a2.052,2.052,0,0,1,.177-.878,2.014,2.014,0,0,1,.924-.977l3.882-1.918c-.157-.216-.32-.455-.49-.718a5.135,5.135,0,0,1-.817-2.795v-1.529a4.321,4.321,0,0,1,8.632,0v1.534a5.136,5.136,0,0,1-.809,2.783c-.167.261-.328.5-.485.717l3.909,1.944c.052.026.1.054.145.081a2.12,2.12,0,0,1,.278.206l.013.012c.039.036.078.074.113.112a1.994,1.994,0,0,1,.365.537h0a2.036,2.036,0,0,1,.19.81v2.712Zm-14.508-1.521h12.988V125.76a.528.528,0,0,0-.048-.2.483.483,0,0,0-.09-.132l-.021-.022-.013-.012a.525.525,0,0,0-.066-.049l-.028-.016-4.425-2.2a1.042,1.042,0,0,1-.342-1.589,12.555,12.555,0,0,0,.745-1.053,3.618,3.618,0,0,0,.568-1.961v-1.534a2.8,2.8,0,0,0-5.591,0v1.529a3.618,3.618,0,0,0,.574,1.969,11.977,11.977,0,0,0,.755,1.058,1.043,1.043,0,0,1,.21.878,1.03,1.03,0,0,1-.555.712l-4.4,2.173a.483.483,0,0,0-.215.235.519.519,0,0,0-.047.23v1.144Zm9.142-4.43,0,.006,0-.006"
        transform="translate(-2504.734 -93.099)"
        fill="#609690"
      />
      {/* Small circular nodes */}
      <path
        id="Path_2456"
        d="M2441.8,219.089a2.045,2.045,0,0,1,1.892,1.041c.02.034.039.069.055.1a2.118,2.118,0,0,1-.183,2.181,2.033,2.033,0,0,1-3.425-.2,2.11,2.11,0,0,1,.75-2.853,2.021,2.021,0,0,1,.91-.277"
        transform="translate(-2437.296 -180.683)"
        fill="#b2d7d3"
      />
      <path
        id="Path_2457"
        d="M2441.8,87.1a2.013,2.013,0,0,1-.91-.277,2.108,2.108,0,0,1-.75-2.853,2.03,2.03,0,0,1,2.8-.765,2.056,2.056,0,0,1,.75.764,2.12,2.12,0,0,1,0,2.089c-.02.034-.039.067-.061.1a2.041,2.041,0,0,1-1.83.943"
        transform="translate(-2437.298 -68.387)"
        fill="#b2d7d3"
      />
      <path
        id="Path_2458"
        d="M2557.706,287.174a2.049,2.049,0,0,1,1.879,1.255,2.111,2.111,0,0,1,.17.834,2.051,2.051,0,1,1-4.1,0,2.111,2.111,0,0,1,.17-.834,2.051,2.051,0,0,1,1.881-1.255Z"
        transform="translate(-2532.791 -236.836)"
        fill="#b2d7d3"
      />
    </SvgIcon>
  );
};

export default ConnectIcon;
